module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-03.5bf3fd6b.svg";